import React from 'react'
import QuoteBackground from "../img/quote.png"

const Quote = () => {
  return (
    <div style={{backgroundImage:`url(${QuoteBackground})`}} className='w-full h-[200px] flex justify-end text-white mt-20'>
        <div className='pt-16 px-10'>
            <p className='font-light italic text-lg'>“Here at Kirche we strive to make sure our clients get only the best”</p><br/>
            <p className='font-bold flex justify-end'>Eng. Claude Kirwa, CEO</p>
        </div>
    </div>
  )
}

export default Quote